@keyframes placeholder-appear {
  100% {
    opacity: 1;
  }
}

@keyframes placeholder-shimmer {
  0% {
    background-position: -25% 0;
  }
  100% {
    background-position: 125% 0;
  }
}

.common-page-swimlane__placeholder__content > * {
  opacity: 0;
}

.common-page-swimlane__placeholder {
  pointer-events: none;
  width: 100%;
  padding-inline: var(--rds-gutter);
  box-sizing: border-box;
  opacity: 0;
  animation-delay: 750ms;
  animation-duration: 500ms;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: placeholder-appear;
  animation-timing-function: ease-out;
}

.common-page-swimlane__placeholder__content {
  background: linear-gradient(
    90deg,
    transparent 0%,
    transparent 20%,
    var(--rds-background-overlay-medium) 50%,

    transparent 80%,
    transparent 100%
  );
  background-size: 200% 100%;
  background-repeat: no-repeat;
  margin: 20px 8px;
  border-radius: 24px;
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-name: placeholder-shimmer;
  animation-timing-function: ease-in-out;
  animation-direction: alternate-reverse;
}
